var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-indicator",attrs:{"data-uuid":_vm.uuid},on:{"click":_vm.click}},[_c('v-icon',{staticClass:"outlined"},[_vm._v("$comment-2px")]),_c('v-icon',{staticClass:"filled"},[_vm._v("$comment-solid")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }